import { baseStates, baseMutations, baseActions, baseGetters } from '@/stores/base';

export const companyAccountActivity = {

    namespaced: true,

    state:
    {
        ...baseStates,
    },

    mutations:
    {
        ...baseMutations,
    },

    actions:
    {
        ...baseActions,
    },

    getters:
    {
        ...baseGetters
    },
};
